import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../components/shared/SEO";
import DashboardNavbar from "../components/shared/DashboardNavbar";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import CreateBlogHeader from "../components/dashboard/CreateBlogHeader";
import BlogBannerUpload from "../components/dashboard/BlogBannerUpload";
import BlogTitleInput from "../components/dashboard/BlogTitleInput";
import BlogEditor from "../components/dashboard/BlogEditor";
import BlogEditorActions from "../components/dashboard/BlogEditorActions";

export default function CreateBlog() {
  const navigate = useNavigate();
  const [bannerImage, setBannerImage] = useState(null);
  const [title, setTitle] = useState("");

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <SEO
        title="Create New Blog | SoloConnect"
        description="Write and publish a new travel blog on SoloConnect."
        keywords="write blog, create blog, blog editor, SoloConnect"
      />
      <DashboardNavbar />

      <main className="flex-grow bg-[#FAFAFB]">
        <div className="max-w-4xl mx-auto px-6 sm:px-10 py-8">
          <CreateBlogHeader />

          <div className="flex flex-col gap-6">
            <BlogBannerUpload image={bannerImage} onImageChange={setBannerImage} />
            <BlogTitleInput title={title} onTitleChange={setTitle} />
            <BlogEditor />
          </div>

          <BlogEditorActions
            onSaveDraft={() => {}}
            onPublish={() => navigate("/dashboard/my-blogs")}
          />
        </div>
      </main>

      <div className="hidden md:block">
        <SoloConnectFooter />
      </div>
      <div className="block md:hidden">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
